module.exports = __webpack_public_path__ + "assets/img/Group_305.fc6d8bf2.png";